import axios from 'axios';

// Built-in Naturopathy & Clinical Tamil Glossary for instant client-side translations
export const TAMIL_GLOSSARY = {
    // Meal Slots
    'early morning': 'அதிகாலை',
    'morning': 'காலை',
    'breakfast': 'காலை உணவு',
    'mid-morning': 'காலை இடைவேளை',
    'mid morning': 'காலை இடைவேளை',
    'lunch': 'மதிய உணவு',
    'post lunch': 'மதிய உணவுக்குப் பின்',
    'afternoon': 'மதியம்',
    'evening': 'மாலை',
    'evening snacks': 'மாலை சிற்றுண்டி',
    'snacks': 'சிற்றுண்டி',
    'dinner': 'இரவு உணவு',
    'night': 'இரவு',
    'bedtime': 'படுக்கைக்கு முன்',

    // Titles & Health Conditions
    'diet chart': 'உணவு முறை அட்டவணை',
    'diet & nutrition chart': 'உணவு முறை மற்றும் ஊட்டச்சத்து அட்டவணை',
    'diet and nutrition chart': 'உணவு முறை மற்றும் ஊட்டச்சத்து அட்டவணை',
    'naturopathy diet chart': 'இயற்கை மருத்துவ உணவு அட்டவணை',
    'weight loss diet': 'எடை குறைப்பு உணவு முறை',
    'weight loss': 'எடை குறைப்பு',
    'weight gain diet': 'எடை அதிகரிப்பு உணவு முறை',
    'weight gain': 'எடை அதிகரிப்பு',
    'diabetes diet': 'சர்க்கரை நோய் (நீரிழிவு) உணவு முறை',
    'diabetes': 'சர்க்கரை நோய் (நீரிழிவு)',
    'hypertension diet': 'இரத்த அழுத்த கட்டுப்பாட்டு உணவு முறை',
    'hypertension': 'உயர் இரத்த அழுத்தம்',
    'detox diet': 'உடல் நச்சு நீக்கும் (டிடாக்ஸ்) உணவு முறை',
    'pcod diet': 'கருப்பை நீர்க்கட்டி (PCOD) உணவு முறை',
    'pcos diet': 'கருப்பை நீர்க்கட்டி (PCOS) உணவு முறை',
    'arthritis diet': 'மூட்டு வலி நிவாரண உணவு முறை',
    'gastritis diet': 'அசிடிட்டி மற்றும் வாயு பிரச்சனை உணவு முறை',
    'skin care diet': 'தோல் ஆரோக்கிய உணவு முறை',

    // Common Naturopathy Foods & Drinks
    'warm water': 'வெந்நீர்',
    'warm lemon honey water': 'எலுமிச்சை தேன் கலந்த வெந்நீர்',
    'lemon honey water': 'எலுமிச்சை தேன் கலந்த வெந்நீர்',
    'lemon water': 'எலுமிச்சை தண்ணீர்',
    'lemon juice': 'எலுமிச்சை சாறு',
    'tender coconut water': 'இளநீர்',
    'coconut water': 'இளநீர்',
    'amla juice': 'நெல்லிக்காய் சாறு',
    'ash gourd juice': 'வெண்பூசணி சாறு',
    'bottle gourd juice': 'சுரைக்காய் சாறு',
    'cucumber juice': 'வெள்ளரிக்காய் சாறு',
    'tomato soup': 'தக்காளி சூப்',
    'vegetable soup': 'காய்கறி சூப்',
    'mixed vegetable soup': 'கலவை காய்கறி சூப்',
    'sprouted green gram': 'முளைகட்டிய பாசிப்பயறு',
    'sprouted moong dal': 'முளைகட்டிய பாசிப்பயறு',
    'sprouts': 'முளைகட்டிய பயறு வகைகள்',
    'sprouts salad': 'முளைகட்டிய பயறு சாலட்',
    'fresh salad': 'புதிய காய்கறி சாலட்',
    'vegetable salad': 'காய்கறி சாலட்',
    'fruit salad': 'பழக் கலவை சாலட்',
    'seasonal fruits': 'பருவகால பழங்கள்',
    'millet porridge': 'சிறுதானிய கஞ்சி',
    'millet idli': 'சிறுதானிய இட்லி',
    'millet dosa': 'சிறுதானிய தோசை',
    'millet khichdi': 'சிறுதானிய கிச்சடி',
    'idli with sambar': 'சாம்பாருடன் இட்லி',
    'mint chutney': 'புதினா சட்னி',
    'coriander chutney': 'கொத்தமல்லி சட்னி',
    'coconut chutney': 'தேங்காய் சட்னி',
    'red rice': 'சிவப்பு அரிசி சாதம்',
    'brown rice': 'கைக்குத்தல் அரிசி சாதம்',
    'steamed vegetables': 'வேகவைத்த காய்கறிகள்',
    'boiled vegetables': 'வேகவைத்த காய்கறிகள்',
    'herbal tea': 'மூலிகை தேநீர்',
    'green tea': 'கிரீன் டீ',
    'buttermilk': 'மோர்',
    'curd': 'தயிர்',
    'papaya': 'பப்பாளி',
    'guava': 'கொய்யா',
    'apple': 'ஆப்பிள்',
    'pomegranate': 'மாதுளை',
    'watermelon': 'தர்பூசணி',
    'soaked almonds': 'ஊறவைத்த பாதாம்',
    'walnuts': 'அக்ரூட் (வால்நட்)',
    'dry grapes': 'உலர் திராட்சை',
    'raisins': 'உலர் திராட்சை',
    'figs': 'அத்திப்பழம்',

    // Instructions
    'chew well': 'நன்றாக மென்று சாப்பிடவும்',
    'chew slowly': 'மெதுவாக மென்று சாப்பிடவும்',
    'chew food slowly and thoroughly': 'உணவை மெதுவாகவும் நன்றாக மென்றும் சாப்பிடவும்',
    'sip slowly': 'மெதுவாக பருகவும்',
    'drink plenty of water': 'போதுமான அளவு தண்ணீர் குடிக்கவும்',
    'avoid oily food': 'எண்ணெய் உணவுகளைத் தவிர்க்கவும்',
    'avoid fried food': 'வறுத்த உணவுகளைத் தவிர்க்கவும்',
    'avoid white sugar': 'வெள்ளை சர்க்கரையைத் தவிர்க்கவும்',
    'avoid tea and coffee': 'டீ, காபி தவிர்க்கவும்',
    'take light walk': 'சிறிது நேரம் நடைப்பயிற்சி செய்யவும்',
    'no water while eating': 'சாப்பிடும் போது தண்ணீர் குடிக்க வேண்டாம்'
};

// Check if string contains Tamil characters
export function hasTamil(text) {
    return /[\u0B80-\u0BFF]/.test(text || '');
}

/**
 * Fast client-side quick translate for slots
 */
export function quickTranslateSlotName(name = '') {
    const trimmed = name.trim().toLowerCase();
    return TAMIL_GLOSSARY[trimmed] || name;
}

/**
 * Translates a diet object into Tamil.
 * Patient details (name, age, gender, doctor, id, date) are preserved in English.
 * @param {Object} diet - diet data object
 * @returns {Promise<Object>} Translated diet data
 */
export async function translateDietToTamil(diet = {}) {
    try {
        const payload = {
            title: diet.title || '',
            condition: diet.condition || '',
            slots: Array.isArray(diet.slots) ? diet.slots : [],
            guidelines: diet.guidelines || ''
        };

        const { data } = await axios.post('/api/v1/diet-translate-tamil', payload);
        if (data && data.success && data.translated) {
            return {
                ...diet,
                title: data.translated.title || diet.title,
                condition: data.translated.condition || diet.condition,
                slots: data.translated.slots || diet.slots,
                guidelines: data.translated.guidelines || diet.guidelines,
                // Patient details are strictly untouched (English)
                patient: diet.patient,
                doctor: diet.doctor,
                date: diet.date
            };
        }
    } catch (err) {
        console.warn('Backend translation failed, falling back to local glossary:', err);
    }

    // Fallback using local glossary
    const fallbackSlots = (diet.slots || []).map(slot => ({
        ...slot,
        title: quickTranslateSlotName(slot.title),
        items: TAMIL_GLOSSARY[(slot.items || '').toLowerCase().trim()] || slot.items,
        instructions: TAMIL_GLOSSARY[(slot.instructions || '').toLowerCase().trim()] || slot.instructions
    }));

    return {
        ...diet,
        title: TAMIL_GLOSSARY[(diet.title || '').toLowerCase().trim()] || diet.title || 'உணவு முறை அட்டவணை',
        condition: TAMIL_GLOSSARY[(diet.condition || '').toLowerCase().trim()] || diet.condition,
        slots: fallbackSlots,
        guidelines: TAMIL_GLOSSARY[(diet.guidelines || '').toLowerCase().trim()] || diet.guidelines,
        patient: diet.patient,
        doctor: diet.doctor,
        date: diet.date
    };
}

